import React, { useState, useEffect } from "react";
import { ReactComponent as Close } from "../../../../assets/images/teamclose.svg";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import MultipleEmail from "../../../dashboardcomponents/MutliEmailSelect";
import { addCCEmailsToTicket } from "../../../../store/features/addCCEmailsToTicket";
import { getTicketMessagesById } from "../../../../store/features/getTicketMessagesById";
import Input from "../../../../components/common/InputField";
import { getTicketById } from "../../../../store/features/getTicketById";

import { isValidEmail } from "../../../../utils/index";

function AddRequesterPopup({ setOpen, ticketId, onAssignSuccess, requesterEmail, existingCCEmails = [], onCCEmailsUpdate }) {
  const dispatch = useDispatch();
  const [ccEmails, setCCEmails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [emailInput, setEmailInput] = useState("");
  const [emailTouched, setEmailTouched] = useState(false);

  useEffect(() => {
    setEmailInput("");
    setCCEmails([]);
    setEmailTouched(false);
  }, [setOpen]);

  // MultipleEmail expects sendValueStore to receive an array of objects: [{ email: ... }]
  const handleEmailsChange = (emailsArr) => {
    setCCEmails(emailsArr.map((item) => item.email));
  };

  const handleInputChange = (e) => {
    setEmailInput(e.target.value);
    setEmailTouched(true);
    setCCEmails([e.target.value]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!ccEmails.length || !isValidEmail(ccEmails[0])) {
      toast.error("Please enter a valid email address.");
      return;
    }
      if(ccEmails[0].length > 100) {
      toast.error("Email cannot exceed 100 characters.");
      return;
    }
    
    const inputEmail = ccEmails[0].toLowerCase();
    const requesterEmailLower = requesterEmail?.toLowerCase();
    const existingCCEmailsLower = existingCCEmails.map(email => email.toLowerCase());
    
    if (inputEmail === requesterEmailLower) {
      toast.error("Requester and In-Loop person cannot have the same email address");
      return;
    }
    if (existingCCEmailsLower.includes(inputEmail)) {
      toast.error("This email is already in the loop.");
      return;
    }
    setLoading(true);
    try {
      await dispatch(
        addCCEmailsToTicket({
          ticketId,
          ccEmails,
        })
      ).unwrap();
      await dispatch(getTicketMessagesById(ticketId)).unwrap();
      
      if (onCCEmailsUpdate) {
        const updatedCCEmails = [...existingCCEmails, ...ccEmails];
        onCCEmailsUpdate(updatedCCEmails);
      }
      
      if (onAssignSuccess) {
        onAssignSuccess();
        await dispatch(getTicketById(ticketId)).unwrap();
      }
      toast.success("CC emails added successfully!");

      setOpen(false);
    } catch (err) {
      toast.error("Failed to add CC emails.");
    } finally {
      setLoading(false);
    }
  };

  const emailIsValid = isValidEmail(emailInput);
  const inputEmailLower = emailInput.toLowerCase();
  const requesterEmailLower = requesterEmail?.toLowerCase();
  const existingCCEmailsLower = existingCCEmails.map(email => email.toLowerCase());
  
  const disableSave =
    loading ||
    !emailInput ||
    !emailIsValid ||
    (ccEmails.length > 0 && inputEmailLower === requesterEmailLower) ||
    (ccEmails.length > 0 && existingCCEmailsLower.includes(inputEmailLower));

  return (
    <>
      <div className="overlay" />
      <div className="Team-PopUp-Container" style={{ maxWidth: "424px" }}>
        <div className="Team-PopUp-Header">
          <p className="PopUp-Text01">Add Requester</p>
          <p className="PopUp-Text02" onClick={() => setOpen(false)}>
            <Close />
          </p>
        </div>
        <form className="PopUp-Email-Container" onSubmit={handleSubmit}>
          <Input
            type="text"
            placeholder="Enter email address"
            title="Email"
            value={emailInput}
            onChange={handleInputChange}
            onBlur={() => setEmailTouched(true)}
           
          />
          <div className="Ticket-Button-Container">
            <button
              className="buttonstyle-Cancel"
              type="button"
              onClick={() => setOpen(false)}
            >
              Cancel
            </button>
            <button
              className="buttonstyle-Ticket"
              type="submit"
              disabled={disableSave}
            >
              {loading ? "Saving..." : "Save"}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default AddRequesterPopup;
